import SavedLists from './Shared/SavedLists';

export default { SavedLists };
